import { Flex, Popconfirm, Tag, Tooltip } from 'antd';
import { AuthorizedIcon, Icon } from '../../../components';
import TrashSolidBlack from '../../../assets/icons/trash-solid-b-black.svg';
import PenToSquareSolidBlack from '../../../assets/icons/pen-to-square-solid-w-black.svg';
import EyeRegularWBlack from '../../../assets/icons/eye-regular-w-black.svg';
import Variant99Black from '../../../assets/icons/variant99-black.svg';
import FolderOpenRegular from '../../../assets/icons/folder-open-regular.svg';
import styles from './index.module.scss';
import { status_colors } from '../../../assets/conts';
import { IEnum } from '../../../services/type';
import { getValueFromEnum } from '../../../utils/functions';
import { ColumnType } from 'antd/es/table';
import { actionTypes } from '../../../assets/enums';
import {
  IFile,
  IOrganization,
  IAbroadInsuranceDataSource,
} from '../../../types';

export const getColumns = (
  handleClickEye: (id: number) => void,
  handleOpenEditModal: (id: number) => void,
  handleClickDelete: (id: number) => Promise<void>,
  handleClickCancel: (id: number) => Promise<void>,
  handleSetAdditionalFile: (id: number, file: IFile[]) => void,
  organizations: IOrganization[],
  branches: IEnum[],
  countries: IEnum[],
  statusChoices: IEnum[],
): Array<ColumnType<IAbroadInsuranceDataSource> & { searchable?: boolean }> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    width: 125,
    searchable: true,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    sorter: (a, b) => a.organization - b.organization,
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Poliçe No',
    dataIndex: 'policy_number',
    key: 'policy_number',
    width: 150,
    searchable: true,
    sorter: (a, b) => a.policy_number - b.policy_number,
  },
  {
    title: 'Branş',
    dataIndex: 'branch',
    key: 'branch',
    width: 125,
    filters: branches.map((item) => ({
      text: getValueFromEnum(branches, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    sorter: (a, b) => a.branch?.localeCompare(b.branch),
    render: (_: unknown, record: IAbroadInsuranceDataSource) => (
      <Tag className={styles[`${record.branch}Tag`]}>
        {getValueFromEnum(branches, record.branch)}
      </Tag>
    ),
  },
  {
    title: 'Ülke',
    dataIndex: 'country',
    key: 'country',
    width: 125,
    filters: countries.map((item) => ({
      text: getValueFromEnum(countries, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    sorter: (a, b) => a.country?.localeCompare(b.country),
    render: (_: unknown, record: IAbroadInsuranceDataSource) => (
      <div>{getValueFromEnum(countries, record.country)}</div>
    ),
  },
  {
    title: 'Başlangıç Tarihi',
    dataIndex: 'start_date',
    key: 'start_date',
    width: 150,
    sorter: true,
  },
  {
    title: 'Bitiş Tarihi',
    dataIndex: 'end_date',
    key: 'end_date',
    width: 120,
    sorter: true,
  },
  {
    title: 'Açıklama',
    dataIndex: 'description',
    key: 'description',
    width: 200,
    sorter: (a, b) => a.description?.localeCompare(b.description),
    render: (_, record) => (
      <Tooltip title={record.description}>
        <span>
          {record.description?.length
            ? `${record.description?.slice(0, 15)}...`
            : ''}
        </span>
      </Tooltip>
    ),
  },
  {
    title: 'Durum',
    dataIndex: 'recent_status',
    key: 'recent_status',
    width: 150,
    filters: statusChoices.map((item) => ({
      text: getValueFromEnum(statusChoices, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    render: (_: unknown, record: IAbroadInsuranceDataSource) => (
      <Tag color={status_colors[record.recent_status]}>
        {getValueFromEnum(statusChoices, record.recent_status)}
      </Tag>
    ),
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    width: 160,
    render: (_: unknown, record: IAbroadInsuranceDataSource) => (
      <Flex justify="flex-end" gap={14}>
        <Icon
          source={EyeRegularWBlack}
          popoverText={actionTypes.VIEW}
          onClick={() => record?.id && handleClickEye(record.id)}
        />
        {record.recent_status !== 'cancelled' && (
          <Popconfirm
            title={
              <div className={styles.popconfirmTitle}>
                İptal işlemini onaylıyor musunuz?
              </div>
            }
            overlayInnerStyle={{
              width: 150,
              borderColor: '#D6222A',
              borderWidth: 1,
              borderStyle: 'solid',
            }}
            okText="Onayla"
            cancelText="İptal"
            icon={null}
            color="#FAFAFA"
            okButtonProps={{ danger: true, style: { width: '45%' } }}
            cancelButtonProps={{ danger: true, style: { width: '45%' } }}
            onConfirm={() => record.id && handleClickCancel(record.id)}
          >
            <AuthorizedIcon
              action="add"
              model="abroadinsurance"
              popoverText={actionTypes.CANCEL}
              source={Variant99Black}
            />
          </Popconfirm>
        )}
        <Popconfirm
          title={
            <div className={styles.popconfirmTitle}>
              Silme işlemini onaylıyor musunuz?
            </div>
          }
          overlayInnerStyle={{
            width: 150,
            borderColor: '#D6222A',
            borderWidth: 1,
            borderStyle: 'solid',
          }}
          okText="Onayla"
          cancelText="İptal"
          icon={null}
          color="#FAFAFA"
          okButtonProps={{ danger: true, style: { width: '45%' } }}
          cancelButtonProps={{ danger: true, style: { width: '45%' } }}
          onConfirm={() => record.id && handleClickDelete(record.id)}
        >
          <AuthorizedIcon
            action="delete"
            model="abroadinsurance"
            popoverText={actionTypes.DELETE}
            source={TrashSolidBlack}
          />
        </Popconfirm>
        <AuthorizedIcon
          action="change"
          model="abroadinsurance"
          popoverText={actionTypes.CHANGE}
          source={PenToSquareSolidBlack}
          onClick={() => record?.id && handleOpenEditModal(record.id)}
        />
        <AuthorizedIcon
          action="view"
          model="abroadinsuranceadditionalfile"
          popoverText={actionTypes.ADDITIONAL_FILE}
          source={FolderOpenRegular}
          onClick={() =>
            handleSetAdditionalFile(record.id, record.additional_files)
          }
        />
      </Flex>
    ),
  },
];
